export default __webpack_public_path__ + "static/media/bruno-abatti.ac5426e5.jpg";